import SubappsViewNew from './SubAppViewNew';

export default SubappsViewNew;
